import { Link } from "react-router-dom";
import useReveal from "@/hooks/useReveal";
import CopyableEmail from "@/components/CopyableEmail";
import { ArrowUpRight } from "lucide-react";

export default function FinalCTA() {
  const ref = useReveal();
  return (
    <section
      data-testid="final-cta"
      className="relative py-28 md:py-40 bg-oxblood text-bone overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-100 pointer-events-none" />
      <div className="container-narrow relative text-center">
        <div ref={ref} className="reveal">
          <div className="text-[11px] uppercase tracking-[0.28em] text-champagne mb-6">
            Begin
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[60px] leading-[1.04] tracking-tight text-balance">
            Start your hospitality
            <br />
            uniform <em className="italic text-champagne">consultation.</em>
          </h2>
          <p className="mt-7 max-w-xl mx-auto text-bone/75 text-[15px] md:text-[17px] font-light leading-relaxed">
            Tell us about your property, concept, rebrand or rollout requirement.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row justify-center gap-4 sm:gap-5">
            <a
              href="https://calendly.com/archanaura8/30min"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-button"
              className="inline-flex items-center justify-center gap-3 bg-bone text-oxblood px-9 py-4 text-sm tracking-[0.18em] uppercase font-medium transition-all duration-500 ease-out hover:bg-champagne hover:text-espresso group"
            >
              Book Design Consultation
              <ArrowUpRight size={16} className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
            <CopyableEmail variant="button" testid="final-cta-email" />
          </div>
        </div>
      </div>
    </section>
  );
}
